import { UserConfig } from "../../../helpers/config/user-config";
import { getSelfUser } from "../../../helpers/auth-helper";
import { TreeDataType } from "../model/TreeItemModel";

const Key = "SelfTreeData";

// ツリーデータヘルパー
export const TreeDataHelper = {
  loadLocalTreeData: (): TreeDataType[] | undefined => {
    const user = getSelfUser();
    const userId = user?.id;
    const data = UserConfig.get(`${Key}_${userId}`) as
      | TreeDataType[]
      | undefined;
    return data;
  },
  saveLocalTreeData: (data: TreeDataType[]): boolean => {
    const user = getSelfUser();
    const userId = user?.id;
    let result = true;
    try {
      UserConfig.set(`${Key}_${userId}`, data);
    } catch (e) {
      result = false;
    }
    return result;
  },
  removeLocalTreeData: () => {
    const user = getSelfUser();
    const userId = user?.id;
    UserConfig.delete(`${Key}_${userId}`);
  },
};
